import React from 'react';
import { Box, Stepper, Step, StepLabel, StepIconProps } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { BOOKING_THEME } from '../bookingTheme';

const STEPS = ['Choose Time', 'Your Details', 'Payment', 'Confirmation'];

interface BookingStepperProps {
  activeStep: number;
}

const BookingStepIcon: React.FC<StepIconProps> = ({ active, completed, icon }) => {
  if (completed) {
    return <CheckCircleIcon sx={{ color: BOOKING_THEME.stepperDone, fontSize: 28 }} />;
  }
  return (
    <Box
      component="span"
      sx={{
        width: 28,
        height: 28,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '0.8rem',
        fontWeight: 600,
        backgroundColor: active ? BOOKING_THEME.stepperActive : '#e0e0e0',
        color: active ? '#fff' : '#999',
      }}
    >
      {icon}
    </Box>
  );
};

const BookingStepper: React.FC<BookingStepperProps> = ({ activeStep }) => {
  return (
    <Stepper
      activeStep={activeStep}
      alternativeLabel
      sx={{
        mb: 3,
        '& .MuiStepLabel-label': {
          fontSize: '0.75rem',
          color: BOOKING_THEME.textSecondary,
          '&.Mui-active': { color: BOOKING_THEME.textPrimary, fontWeight: 600 },
          '&.Mui-completed': { color: BOOKING_THEME.stepperDone },
        },
        '& .MuiStepConnector-line': {
          borderColor: BOOKING_THEME.border,
        },
        '& .MuiStepConnector-root.Mui-completed .MuiStepConnector-line': {
          borderColor: BOOKING_THEME.stepperDone,
        },
      }}
    >
      {STEPS.map((label) => (
        <Step key={label}>
          <StepLabel StepIconComponent={BookingStepIcon}>{label}</StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};

export default BookingStepper;
